import Ajax from './Ajax.js'

const Retire = {
  getRetires: (id = null) => {
    let uri = id !== null
      ? '/retires' + '/' + id
      : '/retires'
    return Ajax.get(uri)
  },

  postRetires: (params) => {
    const payload = params && params.data ? params : {
      data: {
        walletAddress: params.walletAddress || params.wallet_address,
        amount: params.amount !== undefined ? parseFloat(params.amount) : undefined,
        contractAddress: params.contractAddress || params.contract_address,
        tx: params.tx,
        user: params.user
      }
    }
    return Ajax.post('/retires', payload)
  },

  putRetires: (params) => {
    const payload = params && params.data ? params : {
      data: {
        walletAddress: params.walletAddress || params.wallet_address,
        amount: params.amount !== undefined ? parseFloat(params.amount) : undefined,
        contractAddress: params.contractAddress || params.contract_address,
        tx: params.tx,
        user: params.user
      }
    }
    return Ajax.put('/retires/' + params.id, payload)
  },

  delRetires: (id) => {
    return Ajax.delete('/retires/' + id)
  }
}

export default Retire
